import { CombinedState, combineReducers, Reducer } from "redux";

import themeReducer from "./themeReducer";
import authReducer from "./authReducer";
import userReducer from "./userReducer"
import companyReducer from "./companyReducer"
// import a11yReducer from "./a11yReducer"
import propertyReducer from "./propertyReducer"
import facilitiesReducer from "./facilitiesReducer"
import unitsReducer from "./unitsReducer"
import a11yesReducer from "./a11yesReducer"
import unitImagesReducer from "./unitImagesReducer"
import a11yStandardReducer from "./a11yStandardReducer"
import contractsReducer from './contractsReducer'
import servicesReducer from './servicesReducer'
import errorsReducer from './toastsReducer'
import questionsReducer from './questionsReducer'
import { ActionsFromMap, StateFromMap } from "../utils";

const reducers = {
  themeReducer,
  authReducer,
  companyReducer,
  // a11yReducer,
  propertyReducer,
  facilitiesReducer,
  userReducer,
  unitsReducer,
  a11yesReducer,
  unitImagesReducer,
  a11yStandardReducer,
  contractsReducer,
  servicesReducer,
  errorsReducer,
  questionsReducer
}

export const rootReducer = combineReducers(reducers);
type PickReducer<T> = T extends Reducer<CombinedState<infer S>, infer A> ? [S, A] : never;

// type StateActionMap = PickReducer<typeof rootReducer>
export type AppState = StateFromMap<typeof reducers>;

export type AppActions = ActionsFromMap<typeof reducers>// StateActionMap[1]

export type AppStateType = AppState;
